import type { SVGProps } from 'react';
const DawnFlagDJ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-DJ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-DJ_svg__a)">
      <path fill="#1DC837" d="M0 16h22V7.467H0z" />
      <path fill="#82C5F5" d="M0 7.467h22V0H0z" />
      <path fill="#fff" d="m0 0 10.476 8L0 16z" />
      <path
        fill="#E21C21"
        d="m3.667 9.04-1.54 1.117.568-1.836-1.519-1.145 1.89-.017.6-1.826.601 1.826 1.89.017L4.639 8.32l.568 1.836z"
      />
    </g>
  </svg>
);
export default DawnFlagDJ;
